define('v3/Pages/Settings/Services/Browser.Backend',[
	'jquery',
	'BackendBase'

], function ($, BackendBase) {
	function BrowserBackend () {
		BackendBase.call(this);
	};

	BrowserBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(BrowserBackend.prototype, {
		getBrowserSettings: function () {
			return this._getJsonApi('Settings/BrowserSettings');
		},
		updateBrowserSettings: function (browserOptionsModel) {
			return this._put('Settings/BrowserSettings', browserOptionsModel);
		},
		getWebAppAllowedUrls: function () {
			return this._getJsonApi('Settings/WebAppAllowedUrls');
		},
		addWebAppAllowedUrl: function (newUrl) {
			return this._postApi('Settings/WebAppAllowedUrl', newUrl);
		},
		deleteWebAppAllowedUrl: function (urlId) {
			return this._delete('Settings/WebAppAllowedUrl/' + urlId);
		}
	});

	return new BrowserBackend();
});

